import { Button, Flex, theme, Typography } from '@styles';
import { arrayOf, bool, func, number, object } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ProgressDropdown from './ProgressDropdown';

const SidePanel = ({
  containerProps,
  currentActivity,
  currentLesson,
  finalTest,
  isOpen,
  lessons,
  onActivityPress,
  onLessonPress,
}) => {
  const { i18n } = useTranslation();

  const currentLessonId = currentLesson?.id;

  if (!isOpen) {
    return null;
  }

  return (
    <Flex
      bg={theme.colors.white[10]}
      border={`1px solid ${theme.colors.whiteLine[100]}`}
      flexShrink={0}
      maxWidth={300}
      mr={40}
      p={16}
      {...containerProps}
    >
      <Flex
        borderLeftColor={theme.colors.white[30]}
        borderLeftStyle="solid"
        borderLeftWidth={2}
        flexDirection="column"
        gap={20}
        height="100%"
        width="100%"
      >
        {lessons?.map((lesson) => (
          <ProgressDropdown
            currentActivityId={currentActivity?.id}
            isCurrentLesson={
              finalTest
                ? !(
                    finalTest?.id === currentLessonId &&
                    currentLesson?.content_type === 'test'
                  ) && lesson?.id === currentLessonId
                : lesson?.id === currentLessonId
            }
            isLessonPassed={lesson?.is_completed}
            items={lesson?.activities}
            mainId={lesson?.id}
            onActivityPress={onActivityPress}
            onPress={onLessonPress?.({
              activityId: lesson?.activities?.[0]?.id,
              lessonId: lesson?.id,
            })}
            title={lesson?.title}
          />
        ))}

        {finalTest && (
          <Flex flexDirection="column" gap={8} pl={42}>
            <Flex alignItems="center" gap={10} position="relative">
              {finalTest?.id === currentLessonId &&
                currentLesson?.content_type === 'test' && (
                  <Flex
                    backgroundColor={theme.colors.white[100]}
                    borderRadius="50%"
                    display={
                      finalTest?.id === currentLessonId ? 'flex' : 'none'
                    }
                    height={10}
                    left={0}
                    position="absolute"
                    transform="translate(-480%, 0)"
                    width={10}
                  />
                )}
              <Button
                // height={25}
                height="fit-content"
                onClick={onLessonPress?.({
                  activityId: finalTest?.id,
                  isFinalTest: true,
                  lessonId: finalTest?.id,
                })}
                p={0}
                variant="textButton"
              >
                <Typography
                  color={theme.colors.white[100]}
                  textAlign="left"
                  variant="MS-semibold-s14-lh22"
                >
                  {i18n.t('TagFormat.Test.FinalTest')}
                </Typography>
              </Button>
            </Flex>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

SidePanel.propTypes = {
  containerProps: object,
  currentActivity: object.isRequired,
  currentLesson: object.isRequired,
  finalTest: object,
  isOpen: bool.isRequired,
  lastLessonId: number.isRequired,
  lastSubId: number.isRequired,
  lessons: arrayOf(object).isRequired,
  onActivityPress: func.isRequired,
  onLessonPress: func.isRequired,
};

SidePanel.defaultProps = {
  containerProps: {},
  finalTest: null,
};

export default SidePanel;
